import { useCookies } from "@vueuse/integrations/useCookies";

export class CookieFacade {
    private cookie: ReturnType<typeof useCookies> | undefined;

    constructor() {
        if (import.meta.env.SSR) return;
        this.cookie = useCookies();
    }

    public get(name: string) {
        if (this.cookie === undefined) return undefined;
        return this.cookie.get(name);
    }

    public set(name: string, data: unknown) {
        if (this.cookie === undefined) return;
        this.cookie.set(name, data, { sameSite: "lax", path: "/" });
    }

    public remove(name: string) {
        if (this.cookie === undefined) return;
        this.cookie.remove(name, { sameSite: "lax", path: "/" });
    }
}
